<template>
  <div
    @click="
      !Authentecated()
        ? $router.push({
            name: 'login',
          })
        : ''
    "
    class="mt-3"
  >
    <v-btn
      class="text-none font-weight-bold"
      block
      text
      :loading="loading"
      v-if="group.is_request"
      style="border: 1px solid #2d8cff"
      @click="cancelRequest(group)"
    >
      <span style="color: #2d8cff">Cancel Request</span>
    </v-btn>
    <v-btn
      v-else-if="!(group.is_participant || group.is_admin)"
      depressed
      dark
      color="#2d8cff"
      class="text-none font-weight-bold"
      block
      :loading="loading"
      @click="btnHandler"
    >
      {{ actionBtnText }}
    </v-btn>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios";
import commonFunctions from "@/common/commonFunctions";
import { isAuthenticated } from "@/common/commonFunctions.js";

import { mapActions } from "vuex";
export default {
  data: () => ({
    loading: false,
    commonFun: commonFunctions,
    Authentecated: isAuthenticated,
  }),

  computed: {
    group() {
      return this.$store.state.groups.group;
    },
    actionBtnText() {
      if (this.group.group_type === "Premium") {
        return "Pay and Join";
      } else if (this.group.group_type === "Private") {
        return "Request to join";
      } else {
        return "Join";
      }
    },
    isPaymentHappening() {
      return (
        this.group.is_admin_payment_info &&
        this.group.admin_payment_info.verification_status === "Verified"
      );
    },
    detail() {
      let detail = {};
      detail["group_id"] = this.group.id;
      detail["plan"] = this.group.price[0].id;
      detail["user_id"] = this.commonFun.getUserId();
      return detail;
    },
  },

  methods: {
    ...mapActions({
      isParticipantToggle: "groups/setGroupAfterJoin",
      setGroupRequest: "groups/setGroupRequest",
      togglePaymentDetail: "payment/togglePaymentDetail",
      snackBar: "snackBar/showSnack",
    }),
    btnHandler() {
      if (this.group.group_type === "Premium") {
        // console.log("pay and join");
        if (this.isPaymentHappening) {
          this.togglePaymentDetail({ show: true, detail: this.detail });
        } else {
          this.snackBar({
            text: "Payment Process is not active for this group yet",
            color: "warning",
            timeout: 2500,
          });
        }
      } else {
        this.joinGroup(this.group);
      }
    },
    joinGroup(group) {
      this.loading = true;
      let member_type = group.group_type === "Private" ? "request" : "member";
      const hasutmSource = Object.hasOwn(this.$route.query, "utm_source");
      const utmSource = hasutmSource
        ? this.$route.query.utm_source.split("_")[1]
        : null;
      const successHandler = () => {
        this.loading = false;
        if (group.group_type === "Private") {
          // this.setGroupRequest({ state: true });
          this.snackBar({
            text: "Request has been sent to group admin",
            color: "success",
          });
        }
        this.eventBus.$emit("refresh-group-detail");
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["membership_type"] = member_type;
      formData["group"] = group.id;
      formData["member"] = this.commonFun.getUserId();
      if (utmSource) {
        formData["referred_by"] = utmSource;
      }
      Axios.request_POST(
        "/api/join-leave/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    cancelRequest(group) {
      this.loading = true;
      const successHandler = (res) => {
        this.loading = false;
        this.setGroupRequest({ state: false });
        this.snackBar({
          text: "Request Canceled",
          color: "success",
        });
        console.log(res);
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["membership_type"] = "request";
      formData["group"] = group.id;
      formData["member"] = this.commonFun.getUserId();
      Axios.request_DELETE(
        "/api/join-leave/",
        formData,
        {},
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
};
</script>
